








import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';
import {getModule} from 'vuex-module-decorators';

import SystemStatsStore from '@/store/system/SystemStats.store';
import SystemInfoStore from '@/store/system/SystemInfo.store';

import PieChart from '@/components/Utils/Charts/PieChart.vue';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {PieChart},
})
export default class SystemStatsDiskUsage extends Mixins<BaseComponent>(BaseComponent) {
  private statsStore: SystemStatsStore = getModule(SystemStatsStore, this.$store);

  private systemInfoStore: SystemInfoStore = getModule(SystemInfoStore, this.$store);

  @Prop()
  private compact!: boolean;

  private get storageValues(): number[] | null {
    if (!this.statsStore.Stats || !this.systemInfoStore.HardwareInfo) {
      return null;
    }

    return [
      this.statsStore.Stats.Disk.Used,
      this.statsStore.Stats.Disk.Free,
      this.systemInfoStore.HardwareInfo.InternalMemorySize - (this.statsStore.Stats.Disk.Used + this.statsStore.Stats.Disk.Free),
    ];
  }

}
